import React, { useMemo, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTable, useSortBy, useGlobalFilter } from "react-table";

import Box from '@mui/material/Box';

import Typography from '@mui/material/Typography';

import { Auth } from 'aws-amplify';


import { COLUMNS } from './UserColumns';
import AddUserPopUp from "../Components/Overlays/AddUserPopUp";


import MaterialButton from '@mui/material/Button';

import { AiFillCaretDown, AiFillCaretUp } from "react-icons/ai";
import { getUsersByGroup } from "../services/UserService";

import './Users.css';


function Users() {



    let navigate = useNavigate();
    const columns = useMemo(() =>
        COLUMNS, [])


    const [shownData, setShownData] = useState([])

    const [data, setData] = useState([])
    const [userData, setUserData] = useState([])

    const setUsers = async (groupNr) => {
        const data = await getUsersByGroup(groupNr)

        if (!data || !data.Items) {
            return
        }

        setData(data.Items)
        setShownData(data.Items)
    }


    const getUserData = async () => {

        let groupNr = 0;

        let user = await Auth.currentAuthenticatedUser();
        groupNr = user.attributes.locale;
        setUserData(groupNr)
        setUsers(groupNr)
    };

    useEffect(() => {
        getUserData();
    }, []);

    const initialState = { hiddenColumns: ['photoString'] }
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({
        columns,
        data,
        initialState
    },
        useGlobalFilter,
        useSortBy
    )


    const [isOpen, setIsOpen] = useState(false);

    let currentDate = new Date();

    const filterFutureUsers = () => {

        setData(shownData.filter(value => new Date(value.arrivalDate).getTime() > new Date(currentDate).getTime()))
    }

    const filterCurrentUsers = () => {


        Date.prototype.addDays = function (days) {
            var date = new Date(this.valueOf());
            date.setDate(date.getDate() + days);
            return date;
        }

        let firstSort = shownData.filter(value => new Date(value.arrivalDate).getTime() <= new Date(currentDate).getTime())


        setData(firstSort.filter(value => new Date(value.arrivalDate).addDays(20).getTime() > new Date(currentDate).getTime()))
    }

    const filterPreviousUsers = () => {

        Date.prototype.addDays = function (days) {
            var date = new Date(this.valueOf());
            date.setDate(date.getDate() + days);
            return date;
        }


        setData(shownData.filter(value => new Date(value.arrivalDate).addDays(20).getTime() < new Date(currentDate).getTime()))
    }


    const allUsers = () => {
        setData(shownData)
    }


    return (

        <div className="Users">
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start' }}>

                <Typography variant="h4">Brukere</Typography>


                <AddUserPopUp open={isOpen} onClose={() => setIsOpen(false)} />

                {userData == 1 &&
                    <div>
                        <MaterialButton onClick={() => setUsers("2C")}>2C</MaterialButton>
                        <MaterialButton onClick={() => setUsers("2D")}>2D</MaterialButton >
                        <MaterialButton onClick={() => setUsers("2E")}>2E</MaterialButton>
                        <MaterialButton onClick={() => setUsers("1A")}>1A</MaterialButton>
                        <MaterialButton onClick={() => setUsers("1B")}>1B</MaterialButton>
                        <MaterialButton onClick={() => setUsers("TEST")}>TEST</MaterialButton>
                    </div>

                }
                <Box>
                    <MaterialButton onClick={allUsers}>Alle brukere </MaterialButton>
                    <MaterialButton onClick={filterPreviousUsers}>Tidligere</MaterialButton>
                    <MaterialButton onClick={filterCurrentUsers}>Nåværende</MaterialButton >
                    <MaterialButton onClick={filterFutureUsers}>Kommende</MaterialButton>
                </Box>

                <div class="break"></div>

                <table {...getTableProps()}>
                    <thead>
                        {headerGroups.map(headerGroup => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column) => (
                                    <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                        {column.render('Header')}
                                        <span>
                                            {column.isSorted ? (column.isSortedDesc ? <AiFillCaretDown /> : <AiFillCaretUp />) : ' '}
                                        </span>
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {rows.map(row => {
                            prepareRow(row)
                            return (
                                <tr {...row.getRowProps()}>
                                    {row.cells.map((cell) => {
                                        return <td {...cell.getCellProps()} onClick={() => navigate(`/userinfo/${cell.row.values.userId}`,
                                            {
                                                state: {
                                                    week: cell.row.values.weekNumber, name: cell.row.values.firstName, photo: cell.row.values.photoString, group: cell.row.values.groupId, gym: cell.row.values.gym, horse: cell.row.values.horse, musicMove: cell.row.values.musicMove,
                                                    pool: cell.row.values.pool, hike: cell.row.values.hike, canoe: cell.row.values.canoe, climbing: cell.row.values.climbing,
                                                    cycle: cell.row.values.cycle, outdoor: cell.row.values.outdoor, screen: cell.row.values.screen, playOutside: cell.row.values.playOutside, alpin: cell.row.values.alpin, skates: cell.row.values.skates, skiing: cell.row.values.skiing
                                                }
                                            })}>{cell.render('Cell')}</td>
                                    })}

                                </tr>
                            )
                        })}
                    </tbody>
                </table>
                <div class="breakTable"></div>

            </Box>
        </div>
    );
}
export default Users;